import createIcon from '../../createIcon';

/**
 * @component @name KeyboardBackspace
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTFINi44M0wxMC40MSA3LjQxTDkgNkwzIDEyTDkgMThMMTAuNDEgMTYuNTlMNi44MyAxM0gyMVYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardBackspace = createIcon('KeyboardBackspace', [
  ['path', { d: 'M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z', key: '1ght2g' }],
]);

export default KeyboardBackspace;
